import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

export const fetchReportSummary = (searchParams) =>
  getNetwork().get(`${API_ROOT}/edu-report/consolidated?${searchParams}`);